/**
 * Builds the tel: / wa.me / mailto: links contact buttons open — the web equivalent of
 * the app's global/contact.js. The raw phone number and email only ever end up inside
 * an href; ContactGate never prints either as visible text.
 */

// Kenyan numbers arrive as 07…, +2547… or 2547… depending on how they were typed — and
// occasionally as a number rather than a string, so every helper coerces first.
export const toInternational = (phone) => {
  const digits = String(phone).replace(/[^\d+]/g, "");
  if (digits.startsWith("+")) return digits.slice(1);
  if (digits.startsWith("0")) return `254${digits.slice(1)}`;
  return digits;
};

export const callLink = (phone) => `tel:${String(phone).replace(/\s+/g, "")}`;

export const whatsappLink = (phone, message) =>
  `https://wa.me/${toInternational(phone)}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const emailLink = (email, subject) =>
  `mailto:${String(email)}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;
